import tenders from '@/services/apiCalls/tenders/tenders'

export default {
  methods: {
    /**
     * @description Checks tender`s starred status
     * @param { String } tenderId
     * @return { Boolean }
     */
    isStarred(tenderId) {
      return this.$store.state.starredTendersIds.includes(tenderId);
    },
    /**
     * @description Checks tender`s starred status and changes it to opposite value
     * @param { String } tenderId
     */
    async toggleStarredStatus(tenderId) {
      const isStarred = this.$store.state.starredTendersIds.includes(tenderId)
      if (isStarred) {
        await this.removeTenderFromStarred(tenderId)
      } else {
        await this.addTenderToStarred(tenderId)
      }
    },
    /**
     * @description Adds tender to starred
     * @param { String } tenderId
     */
    async addTenderToStarred(tenderId) {
      if (this.isStarred(tenderId)) {
        this.$store.commit('openSnackBar', {
          text: this.$gettext('The tender has been already starred'),
          color: 'warning',
        });
        return;
      }
      try {
        await tenders.starItem(tenderId)
        this.$store.commit('addStarredId', tenderId)
        this.$store.commit('openSnackBar', {
          text: this.$gettext('The tender has been starred'),
          color: 'success',
        });
      } catch (e) {
        console.error(e)
      }
    },
    /**
     * @description Removes tender from starred
     * @param { String } tenderId
     */
    async removeTenderFromStarred(tenderId) {
      if (!this.isStarred(tenderId)) {
        this.$store.commit('openSnackBar', {
          text: this.$gettext('The tender has been already unstarred'),
          color: 'warning',
        });
        return;
      }
      try {
        await tenders.unstarItem(tenderId);
        this.$store.commit('removeStarredId', tenderId);
        this.$store.commit('openSnackBar', {
          text: this.$gettext('The tender has been unstarred'),
          color: 'success',
        });
      } catch (e) {
        console.error(e);
      }
    },
  },
};
